import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './SignUp.css';
import Footer from '../../components/Footer/Footer';
import { signUp } from '../../api/api.js';
import Notification from '../../components/notification.js';
import { validateForm } from '../../components/passwordCheck/passwordCheck.js';

const SignUp = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
  });

  const [errors, setErrors] = useState({});
  const [notification, setNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

    setErrors({
      ...errors,
      [e.target.name]: '',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!form.username) newErrors.username = 'Username is required.';
    if (!form.email) newErrors.email = 'Email is required.';
    if (!form.password) newErrors.password = 'Password is required.';

    try {
      const validationErrors = validateForm(form);
      if (Object.keys(validationErrors).length === 0) {
        setIsLoading(true);
        const data = await signUp({ username: form.username, email: form.email, password: form.password });
        console.log(data);

        setNotification({ type: 'success', message: data.data.data.message });
        navigate('/otp', { state: { email: form.email } });
      } else {
        const firstError = Object.values(validationErrors)[0][0];
        setNotification({ type: 'error', message: firstError });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.data?.message || 'An error occurred during sign-up.';
      setNotification({ type: 'error', message: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseNotification = () => {
    setNotification(null);
  };

  return (
    <div className="page-container">
      <main className="main-content">
        <div className="signup-container">
          <form className="signup-form" onSubmit={handleSubmit}>
            <h2 className="signup-title">Create an Account</h2>
            <p className="signup-description">Fill in the details below to get started.</p>

            <div className="signup-inputs">
              <div className="signup-input-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  value={form.username}
                  onChange={handleChange}
                  className={errors.username ? 'signup-input-error' : ''}
                  required
                  disabled={isLoading}
                />
                {errors.username && <span className="signup-error-message">{errors.username}</span>}
              </div>

              <div className="signup-input-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={form.email}
                  onChange={handleChange}
                  className={errors.email ? 'signup-input-error' : ''}
                  required
                  disabled={isLoading}
                />
                {errors.email && <span className="signup-error-message">{errors.email}</span>}
              </div>

              <div className="signup-input-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  value={form.password}
                  onChange={handleChange}
                  className={errors.password ? 'signup-input-error' : ''}
                  required
                  disabled={isLoading}
                />
                {errors.password && <span className="signup-error-message">{errors.password}</span>}
              </div>
            </div>

            <button
              type="submit"
              className="signup-button"
              disabled={isLoading}
            >
              {isLoading ? 'Signing Up...' : 'Sign Up'}
            </button>

            <p className="signup-signin-link">
              Already have an account? <Link to="/sign-in">Sign In</Link>
            </p>
          </form>
        </div>
      </main>
      <Footer />

      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
};

export default SignUp;
